// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"6034851b","330":"ce2147b7","379":"863b28fa","453":"980a2fbf","532":"8f1099b0","710":"26ca95bb","896":"1496cf06"}[chunkId] + ".chunk.js";
};